// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3oZUp","resendInfoText":"OnGoingPaymentBox_resendInfoText__1MFh8"};